import React from 'react';
import CampaignDetail from '../pages/CampaignDetail';
import WbShell, { WbTopBar } from './WbShell';
import { useWbNavigate, useWbRoute } from './WbRouteContext';
import { useParams } from 'react-router-dom';
import { clearAuth } from '../utils/auth';

export default function WbCampaignDetail() {
  const { clientId } = useParams();
  const navigate = useWbNavigate();
  const { routePrefix } = useWbRoute();

  return (
    <WbShell banner={false}>
      <WbTopBar
        title="Кампания"
        backTo={() => navigate(`/client/${clientId}`)}
        onLogout={() => {
          clearAuth();
          navigate('/login');
        }}
      />
      <main className="p-6">
        <CampaignDetail routePrefix={routePrefix} />
      </main>
    </WbShell>
  );
}
